<template>
    <Modal>
        <template #title>Edit the user data (ID: {{ id }})</template>

        <form id="form" @submit.prevent="formSubmit">
            <div class="form-field">
                <label class="form-field-label">
                    Name:
                </label>
                <input type="text" v-model="userName">
                <small v-if="errorUserName" class="error-text">{{ errorUserName }}</small>
            </div>

            <div class="form-field">
                <label class="form-field-label">
                    E-mail:
                </label>
                <input type="text" v-model="email">
                <small v-if="errorEmail" class="error-text">{{ errorEmail }}</small>
            </div>

            <div class="form-field">
                <label class="form-field-label">
                    Password:
                </label>
                <input type="text" v-model="password">
                <small v-if="errorPassword" class="error-text">{{ errorPassword }}</small>
            </div>

            <br>
            <div class="inline-row">
                <div v-if="disableSpecialFieldEdit" class="admin-info">*The admin cannot change these fields on their own</div>

                <div class="flex">
                    <div class="form-field flex">
                        <label class="form-field-label">Role:</label>
                        <DropdownDefault
                                :list="rolesList"
                                :current="currentRole"
                                :disable="disableSpecialFieldEdit"
                                @select="setRole"
                        ></DropdownDefault>
                    </div>

                    <div class="form-field flex">
                        <label class="form-field-label">Status:</label>
                        <DropdownDefault
                                :list="statusList"
                                :current="currentStatus"
                                :disable="disableSpecialFieldEdit"
                                @select="setStatus"
                        ></DropdownDefault>
                    </div>
                </div>
            </div>

        </form>

        <br>

        <template #footer>
            <Button class="gray" @click="closeModal">Cancel</Button>

            <Button type="submit" form="form">Save</Button>
        </template>
    </Modal>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import Modal from "../../../components/Modal";
    import Button from "../../../components/Button";
    import DropdownDefault from "../../../components/DropdownDefault";

    export default {
        name: "EditUserModal",

        components: {
            DropdownDefault,
            Button,
            Modal,
        },

        props: [
            'user',
        ],

        data() {
            return {
                id: null,
                userName: '',
                email: '',
                password: '',
                role: '',
                status: false,

                errorUserName: false,
                errorEmail: false,
                errorPassword: false,

                rolesList: [
                    {
                        name: 'User',
                        value: 'user',
                    },
                    {
                        name: 'Admin',
                        value: 'admin',
                    },
                ],

                statusList: [
                    {
                        name: 'Active',
                        value: true,
                    },
                    {
                        name: 'Banned',
                        value: false,
                    },
                ],

            }
        },

        computed: {
            ...mapState('authentication', [
                'userId',
            ]),

            currentRole() {
                return this.rolesList.find(role => role.value === this.role);
            },

            currentStatus() {
                return this.statusList.find(status => status.value === this.status);
            },

            disableSpecialFieldEdit() {
                // disable edit special fields: 'role', 'active'
                // if the edited user is also the current editor(user)
                return +this.userId === +this.id;
            },

        },

        methods: {
            ...mapActions('users', [
                'editUser',
            ]),

            closeModal() {
                this.$emit('closeModal');
            },

            initData() {
                let { id, userName, email, password, role, active } = this.user;

                this.id = id;
                this.userName = userName;
                this.email = email;
                this.password = password;
                this.role = role;
                this.status = active;
            },

            setRole(value) {
                this.role = value;
            },

            setStatus(value) {
                this.status = value;
            },

            resetErrors() {
                this.errorUserName = false;
                this.errorEmail = false;
                this.errorPassword = false;
            },

            formSubmit() {
                const id = this.id;
                const userName = this.userName;
                const email = this.email;
                const password = this.password;
                const role = this.role;
                const active = this.status;

                this.editUser({ id, userName, email, password, role, active })
                    .then(() => {

                        this.closeModal();

                    }, (err) => {

                        // backend validation errors
                        this.errorUserName = err['userName'];
                        this.errorEmail = err['email'];
                        this.errorPassword = err['password'];
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },

        },

        beforeMount() {
            this.initData();
        },

    }
</script>

<style scoped>
    .inline-row .form-field {
        width: 50%;
    }

    .inline-row .form-field-label {
        margin-right: 10px;
    }

    .admin-info {
        margin: 0 0 4px;
        font-size: 12px;
        color: #999;
    }

</style>